import { jsx as r } from "react/jsx-runtime";
import { Hint as c } from "@systemeio/ui";
var i = /* @__PURE__ */ ((e) => (e.Adaptive = '"SF Pro Display", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"', e.Arial = "Arial, Helvetica, sans-serif", e.ArialBlack = "Arial Black, Gadget, sans-serif", e.Lucida = "Lucida sans unicode,lucida grande,sans-serif", e.Verdana = "verdana,geneva,sans-serif", e.Tahoma = "tahoma,geneva,sans-serif", e.TrebuchetMS = "trebuchet ms,helvetica,sans-serif", e.TimesNewRoman = "times new roman,times,serif", e.Georgia = "georgia, serif", e.Garamond = "garamond, serif", e.CourierNew = "courier new,courier,monospace", e.BrushScriptMT = "brush script mt, cursive", e.Helvetica = "Helvetica, Arial, sans-serif", e.ComicSansMS = "Comic Sans MS, sans-serif", e.Impact = "Impact, Charcoal, sans-serif", e))(i || {});
const a = (e) => (e.split(",")[0] ?? "").toLowerCase().replace(/["']/g, "").replace(/,/g, "_"), o = (e) => {
  switch (a(e)) {
    case a(
      '"SF Pro Display", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
      /* Adaptive */
    ):
      return "Adaptive";
    case a(
      "Arial, Helvetica, sans-serif"
      /* Arial */
    ):
      return "Arial";
    case a(
      "Arial Black, Gadget, sans-serif"
      /* ArialBlack */
    ):
      return "Arial Black";
    case a(
      "Lucida sans unicode,lucida grande,sans-serif"
      /* Lucida */
    ):
      return "Lucida";
    case a(
      "verdana,geneva,sans-serif"
      /* Verdana */
    ):
      return "Verdana";
    case a(
      "tahoma,geneva,sans-serif"
      /* Tahoma */
    ):
      return "Tahoma";
    case a(
      "trebuchet ms,helvetica,sans-serif"
      /* TrebuchetMS */
    ):
      return "Trebuchet MS";
    case a(
      "times new roman,times,serif"
      /* TimesNewRoman */
    ):
      return "Times New Roman";
    case a(
      "georgia, serif"
      /* Georgia */
    ):
      return "Georgia";
    case a(
      "garamond, serif"
      /* Garamond */
    ):
      return "Garamond";
    case a(
      "courier new,courier,monospace"
      /* CourierNew */
    ):
      return "Courier New";
    case a(
      "brush script mt, cursive"
      /* BrushScriptMT */
    ):
      return "Brush Script MT";
    case a(
      "Helvetica, Arial, sans-serif"
      /* Helvetica */
    ):
      return "Helvetica";
    case a(
      "Comic Sans MS, sans-serif"
      /* ComicSansMS */
    ):
      return "Comic Sans MS";
    case a(
      "Impact, Charcoal, sans-serif"
      /* Impact */
    ):
      return "Impact";
    default:
      return e;
  }
}, p = () => Object.values(i).filter(
  (e) => e !== '"SF Pro Display", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  /* Adaptive */
).map((e) => {
  const s = o(e);
  return {
    id: a(e),
    fontFamilyValue: e,
    caption: s,
    customCaption: /* @__PURE__ */ r("div", { style: { fontFamily: e }, children: s })
  };
}), f = (e) => Object.values(i).map((s) => {
  const t = o(s), n = s === '"SF Pro Display", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
  return {
    id: a(s),
    fontFamilyValue: s,
    caption: t,
    customCaption: /* @__PURE__ */ r("div", { style: { fontFamily: s }, children: n ? /* @__PURE__ */ r(c, { mode: "hover", label: e("font_family.adaptive_hint"), children: e("font_family.adaptive") }) : t })
  };
});
export {
  i as FontFamilyEnum,
  f as getEmailFontFamilyOptionsData,
  a as getFontFamilyCode,
  o as getFontFamilyLabel,
  p as getFontFamilyOptionsData
};
